import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { NewsWall as N } from '../../features/newsWall'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

type NewsWallProps = {
  id?: string
  selectedDate?: Date
} & RouteProps

export function NewsWall(props: NewsWallProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  const state: NewsWallProps = props.location?.state as NewsWallProps

  return <N selectedDate={state?.selectedDate} />
}
